import type { HTMLAttributes } from "react";

import styles from "./Badge.module.css";

/** Mirrors the document-control status family already in tokens.css
 *  (published/review/draft) plus a neutral tag tone and danger for parity
 *  with the rest of the system. */
export type BadgeTone = "neutral" | "success" | "warning" | "muted" | "danger";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  /** Small leading dot — for status badges (Active/Published), not tags (roles/categories). */
  dot?: boolean;
}

/**
 * The one status/role/tag pill used everywhere — replaces per-feature
 * reimplementations (manual status chips, Access Management's role/status
 * badges, Restricted Sections' role badges, the approvals queue's
 * new-page/change-to-published tags) that had each picked their own size and
 * color pairing independently.
 */
export function Badge({ tone = "neutral", dot = false, className, children, ...rest }: BadgeProps) {
  const cls = [styles.badge, styles[tone], dot ? styles.withDot : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}
